import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FeatureFlags.module.css';
import { FeatureFlag, toggleFeatureFlag, useFeatureFlag } from '@/services/featureFlags/featureFlags.service';
import { Page } from '@/components/Page/Page';

const FeatureFlags: FC = () => {
  const { t } = useTranslation();
  const isModifiersEnabled = useFeatureFlag(FeatureFlag.ENABLE_MODIFIERS);

  return (
    <Page
      title={t('admin.featureFlags.pageTitle', 'Feature Flags')}
      header={t('admin.featureFlags.pageTitle', 'Feature Flags')}
      breadcrumb={{ label: t('admin.dashboard', 'Dashboard'), to: '/' }}
    >
      <div className={styles.page}>
        <div className={styles.container}>
          <div className={styles.description}>
            <p>
              {t(
                'admin.featureFlags.pageDescription',
                'This page allows administrators to toggle feature flags to enable or disable specific functionality across the application.',
              )}
            </p>
          </div>
          <div className={styles.flagsSection}>
            <h2>{t('admin.featureFlags.availableFlags', 'Available Flags')}</h2>
            <div className={styles.flagItem}>
              <label className={styles.flagLabel} htmlFor="enableModifiersCheckbox">
                <input
                  id="enableModifiersCheckbox"
                  type="checkbox"
                  checked={isModifiersEnabled}
                  onChange={(e) => toggleFeatureFlag(FeatureFlag.ENABLE_MODIFIERS, e.target.checked)}
                  className={styles.flagCheckbox}
                />
                {t('admin.featureFlags.enableModifiers', 'Enable Modifiers Functionality')}
              </label>
              <p className={styles.flagDescription}>
                {t(
                  'admin.featureFlags.enableModifiersDescription',
                  'When enabled, franchisees can access the Modifiers tab in the navigation pane. When disabled, the Modifiers tab is hidden.',
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default FeatureFlags;
